module.exports = __webpack_public_path__ + "img/light-switch-on.0615ce24.svg";